import { compareBackups } from './backup-compare';
import { createBackupFile, readBackupFile } from './backup-file';
import { makeLocalBackup } from './local-backup';

/** Read again after producing the file; never mark a stale snapshot as current. */
export async function prepareVerifiedBackup(read=makeLocalBackup) {
  const snapshot=await read();
  const file=await createBackupFile(snapshot);
  const decoded=await readBackupFile(file.blob);
  const source=compareBackups(decoded.backup,snapshot);
  if(source.missing||source.different||source.extra)throw new Error('Не удалось проверить содержимое копии. Файл не сохранён.');
  const current=await read();
  const comparison=compareBackups(decoded.backup,current);
  if(comparison.missing||comparison.different||comparison.extra)throw new Error('Данные изменились во время создания копии. Повторите сохранение.');
  return {snapshot,file,comparison};
}
